import { ReportGroupBy } from '../filter/filter.const';

export const Filter = [
  { id: ReportGroupBy.Day, text: 'ngày' },
  { id: ReportGroupBy.Hour, text: 'giờ' },
  { id: ReportGroupBy.Source, text: 'nguồn' },
  { id: ReportGroupBy.Called, text: 'đầu số' },
  { id: ReportGroupBy.Queue, text: 'hàng đợi' },
  { id: ReportGroupBy.Campaign, text: 'chiến dịch' },
];

export class ChannelConst {
  static displayColumns = groupBy => {
    const groups = groupBy.split(',');
    let data = [
      {
        title: 'Tổng số cuộc',
        key: 'totalCalls',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổng số cuộc trả lời',
        key: 'totalAnswerCalls',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổng số cuộc nhỡ',
        key: 'totalMissCalls',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tỉ lệ cuộc nhỡ (%)',
        key: 'missRatio',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'SLA (10s)',
        key: 'slaRatio',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'SLA (20s)',
        key: 'slaRatio20',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian chờ TB',
        key: 'avgWaitingTime',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tốc độ trả lời TB',
        key: 'avgSpeedAnswer',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian trả lời TB',
        key: 'avgAcdTime',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian hold TB',
        key: 'avgHoldTime',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian cuộc nhỡ TB',
        key: 'avgMissDuration',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian cuộc gọi TB',
        key: 'avgDuration',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian đàm thoại Max',
        key: 'longestAcdTime',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổng thời gian cuộc gọi',
        key: 'totalDurationFmt',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
    if (groups.includes(ReportGroupBy.Campaign)) {
      data = [
        {
          title: 'Chiến dịch',
          key: 'campaignId',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    if (groups.includes(ReportGroupBy.Queue)) {
      data = [
        {
          title: 'Hàng đợi',
          key: 'queueId',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    if (groups.includes(ReportGroupBy.Called)) {
      data = [
        {
          title: 'Đầu số',
          key: 'called',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    if (groups.includes(ReportGroupBy.Source)) {
      data = [
        {
          title: 'Nguồn',
          key: 'source',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    if (groups.includes(ReportGroupBy.Hour)) {
      data = [
        {
          title: 'Giờ',
          key: 'hr',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    if (groups.includes(ReportGroupBy.Day)) {
      data = [
        {
          title: 'Ngày',
          key: 'dt',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    return data;
  };
  static displayMissRatioColumn = ratio => {
    return ratio + '%';
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/report/channels/channel.const.ts